import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { ArticleFlat, ArticleView } from 'types'
import { NewCollabItem } from '../NewCollabItem/NewCollabItem'
import { ScrollContainer } from '../ScrollContainer/ScrollContainer'
import Styles from './Collaboration.module.scss'
import { List } from './List'
import { CollabItemsFilters } from '../CollabItemsFilters/CollabItemsFilters'
import { Card } from 'components/DocRightRail/screens/AIAssistant/Card'
import { useInformalFeedbackRequests } from 'hooks/almanacFiles/useInformalFeedbackRequests'
import { useArticleView } from 'providers/ArticleViewProvider/ArticleViewProvider'
import { ReviewRequestCardContainer } from 'components/DocRightRail/screens/AIAssistant/ReviewRequestCard/ReviewRequestCardContainer'
import cx from 'classnames'

interface Props {
  onClose?: () => void
  article: ArticleFlat
}

export const Collaboration = observer(({ article, onClose }: Props) => {
  const docStore = useDocStore()
  const articleIsUnlocked = !!article && !article.locked
  const articleView = useArticleView()
  const { openRequest, mostRecentClosedRequest } = useInformalFeedbackRequests(article.almanac_file.id || '')
  const request = openRequest || mostRecentClosedRequest

  return (
    <ScrollContainer className={Styles.scrollContainer}>
      {articleView === ArticleView.Commenting && (
        <div className={Styles.requestCardContainer}>
          <ReviewRequestCardContainer request={request} channel={article.channel} assetType="article" />
        </div>
      )}
      <Card className={cx(Styles.card, { [Styles.commenting]: articleView === ArticleView.Commenting })}>
        <CollabItemsFilters workspaceId={article.almanac_file.workspace.id} onClose={onClose} />
        <div className={Styles.sections}>
          {!docStore.filters.activeKeys.has('trackedChanges') && articleIsUnlocked && (
            <div className={Styles.itemWrapper}>
              <NewCollabItem />
            </div>
          )}
          <List workspaceId={article.almanac_file.workspace.id} />
        </div>
      </Card>
    </ScrollContainer>
  )
})
